import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdminSiteContentResponse } from '@uw/core/api/models';
import { AdminSiteContentService } from '@uw/core/services/admin-site-content.service';
import { SubHeaderService } from '@uw/themes/services/subheader.service';
import { map } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { SafeHtmlPipe } from '../shared/pipes/safe-html.pipe';

@Component({
    selector: 'uw-help-desk',
    templateUrl: './help-desk.component.html',
    styleUrls: ['./help-desk.component.scss'],
    imports: [AsyncPipe, SafeHtmlPipe]
})
export class HelpDeskComponent {

  private _adminSiteContent$ = this._adminSiteContentService.get().pipe(
    map(adminSiteContents => adminSiteContents.filter(x => x.adminContentPageMasterID == 2)[0]),
    map(adminSiteContent => adminSiteContent || {} as AdminSiteContentResponse)
  )


  readonly vm$ = this._adminSiteContent$.pipe(
    map(content => {

      this._subHeaderService.setTitle(this._translateService.currentLang == "en" ? content.adminSiteContentName! : content.adminSiteContentName_Fr!);
      this._subHeaderService.setSubTitle(null);

      return {
        currentLang: this._translateService.currentLang,
        content: this._translateService.currentLang == "en" ? content.content! : content.content_Fr!
      }
    })
  )


  constructor(
    private readonly _adminSiteContentService: AdminSiteContentService,
    private readonly _translateService: TranslateService,
    private readonly _subHeaderService: SubHeaderService
  ) {

  }
}
